/**
 * components/team/RoleChip.js
 * A role as a coloured chip. `label` overrides the key text when a screen has
 * something more useful to say (the vendor page shows "Manager (default)" for
 * a member who predates roles, and a custom role's own name). Custom roles
 * share one navy tint so they read as "yours" without a "(custom)" suffix.
 */
import React from "react";
import { S, ROLE_META } from "./teamStyles.js";

const CUSTOM = { color: "#083860", bg: "#e6eef6" };

const RoleChip = ({ roleKey, builtin = true, label }) => {
  const m = builtin ? ROLE_META[roleKey] || { color: "#334155", bg: "#e2e8f0" } : CUSTOM;
  return (
    <span className="lk-pill" style={S.badge(m.bg, m.color)}>
      {label || roleKey}
    </span>
  );
};

export default RoleChip;
